import * as React from 'react';
import Button from '~/common/elements/mobile/Button';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import { buttonColor, buttonSize, buttonStyle, icons } from '~/common/elements/mobile/consts';

interface Props {
  children: any;
  wrapperClass?: string;
}


export const PopLoading = () => {
  return (
    <div className="load__cont ">
      <div className="load__logo">
        <img className="load__logo--m" src="/assets/img/logo-mark.svg" alt="" />
        <img className="load__logo--t" src="/assets/img/logo-text.svg" alt="" />
      </div>
    </div>
  );
};

export const PopPaymentStart = () => {
  return (
    <div className="">
      <div className="m__head app--md__box">
        <div className="m__head__left">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-delay" />
          </a>
        </div>
        <div className="m__head__cent">
          <a href="javascript:void(null)" className="m__head__logo">
            <img className="" src="/assets/img/logo-mark.svg" alt="" />
          </a>
        </div>
        <div className="m__head__right">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-help" />
          </a>
        </div>
      </div>

      <div className="m__body app--md__box">
        <div className="m__body__titl">New Payment</div>
        <p className="m__body__info">
          <a href="javascript:void(null)" className="m__body__anch">Need assistance?</a>
        </p>

        <div className="form__cont">
          <div className="input input--sm input--sign input--default">
            <span className="input--sign__sign">$</span>
            <input type="text" />
            <label className="input__lbl">Payment Amount</label>
          </div>

          <div className="input input--sm input--sign input--active">
            <span className="input--sign__sign">#</span>
            <input type="text" />
            <label className="input__lbl">Relay Code</label>
          </div>

          <div className="input input--sm input--sign input--active">
            <span className="input--sign__sign">#</span>
            <input type="text" />
            <label className="input__lbl">PO Number</label>
          </div>

        </div>

        <div className="form--rows">
          <div className="m__body__lbl">Select Payment Type</div>
          <div className="m__body__tags">
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">EFS</a>
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag btn--tag--active">Tchek</a>
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
            <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
          </div>
        </div>
      </div>

      <div className="m__foot app--md__box">
        <div className="m__foot__btns">
          <a href="javascript:void(null)" className="btn btn--lgry btn--xlg ">
            Complete fields to continue
          </a>
        </div>
      </div>

    </div>
  );
};

export const LoginView = () => {
  return (
    <div className="m--login">
      <div className="m--login__head">
        <div className="logo--inline">
          <img className="logo--m" src="/assets/img/logo-mark.svg" alt="" />
          <img className="logo--t" src="/assets/img/logo-text.svg" alt="" />
        </div>
        <p className="m--login__titl">Secure and instant payments.<br />Built for logistics.</p>
      </div>
      <div className="m__body app--md__box">

        <div className="form__cont">
          <div className="input input--sm input--active">
            <input type="text" placeholder="Email" />
            <label className="input__lbl">EMAIL</label>
          </div>

          <div className="input input--sm">
            <input type="password" placeholder="Password" />
            <label className="input__lbl">Password</label>
          </div>

          <div className="m__foot__btns">
            <a href="javascript:void(null)" className="btn btn--lgry btn--xlg ">
              Login
            </a>
            <a href="javascript:void(null)" className="btn btn--text--dark btn--xlg ">
              Forget Password?
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PopPaymentFlow = () => {
  return (
    <div className="">
      <div className="m__head app--md__box">
        <div className="m__head__left">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-arw-l" />
          </a>
        </div>
        <div className="m__head__cent">
          <span className="m__head__titl">
            $45.50 (EFS)
          </span>
        </div>
        <div className="m__head__right">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-help" />
          </a>
        </div>
      </div>

      <div className="m__body app--md__box">

        <div className="form__cont">
          <div className="input input--sm">
            <input placeholder="Enter express code" type="text" />
            <label className="input__lbl">Express Code</label>
            <a href="javascript:void(null)" className="input__help">Where can i find this?</a>
          </div>

          <div className="input input--sm">
            <input placeholder="Enter check number (optional)" type="text" />
            <label className="input__lbl">Check Number</label>
          </div>

          <div className="input input--sm">
            <input placeholder="Enter driver’s license number" type="text" />
            <label className="input__lbl">Driver's License</label>
          </div>

          <div className="input input--sm">
            <input placeholder="Select driver’s license state" type="text" />
            <label className="input__lbl">Driver's License State</label>
          </div>

        </div>
      </div>

      <div className="m__foot app--md__box">
        <div className="m__foot__btns">
          <a href="javascript:void(null)" className="btn btn--prim btn--xlg ">
            Process Payment
          </a>
        </div>
      </div>

    </div>
  );
};

export const PopSuccess = () => {
  return (
    <div className="m--success ">

      <div className="m__body app--md__box">
        <div className="m__body__i lg"><span className="i i-truck" /></div>
        <div className="m__body__titl--lg">Good to go!</div>

        <p className="m__body__info">
          <a href="javascript:void(null)" className="m__body__anch">Need assistance?</a>
        </p>
        <p className="m__body__info">$45.50 EFS payment has been <br /> processsed. <a href="javascript:void(null)"
                                                                                       className="m__body__anch">See
          details.</a></p>
        <p className="m__body__info">Confirmation Number <br /> <span className="m__body__info__note">9273</span></p>
      </div>

      <div className="m__foot app--md__box">
        <div className="m__foot__btns">
          <div className="color--prim">
            <a href="javascript:void(null)" className="btn btn--outl--lite btn--xlg">
              <span className="btn__i">
                <span className="i i-mail" />
              </span>
              Complete fields to contniue
            </a>
          </div>
          <a href="javascript:void(null)" className="btn btn--outl btn--xlg dn">Complete fields to contniue</a>
          <a href="javascript:void(null)" className="btn btn--outl btn--xlg">
            <span className="btn__i">
              <span className="i i-mail" />
            </span>
            Send Recipet as Email
          </a>
          <a href="javascript:void(null)" className="btn btn--lgry btn--xlg ">
            <span className="btn__i">
              <span className="i i-msg" />
            </span>
            Send as a text
          </a>
          <a href="javascript:void(null)" className="btn btn--prim btn--xlg dn">Complete fields to contniue</a>
        </div>
      </div>
    </div>
  );
};

export const PopSuccess_NEW = () => {
  return (
    <div className="m--success ">

      <div className="m__body app--md__box">
        <div className="m__body__i lg"><span className="i i-truck" />
        </div>

        <div className="m__body__titl--lg">Good to go!</div>

        <p className="m__body__info">Process a transaction in 60 seconds. <br /> <a href="javascript:void(null)"
                                                                                    className="m__body__anch">Need
          assistance?</a></p>
        <p className="m__body__info">$45.50 EFS payment has been <br /> processsed.
          <a href="javascript:void(null)" className="m__body__anch">See details.</a>
        </p>

        <p className="m__body__info">Confirmation Number <br />
          <span className="m__body__info__note">9273</span>
        </p>

      </div>

      <div className="m__foot app--md__box">


        <FooterWrapper>
          <Button
            title="Complete fields to contniue"
            buttonStyle={buttonStyle.OUTL_LITE}
            buttonSize={buttonSize.XLG}
            buttonColor={buttonColor.PRIM}
            iconType={icons.MAIL}
            onClick={() => {
            }}
          />
          <Button
            title="Send Recipet as Email"
            buttonStyle={buttonStyle.OUTL}
            buttonSize={buttonSize.XLG}
            iconType={icons.MAIL}
            onClick={() => {
            }}
          />
          <Button
            title="Send as a text"
            buttonStyle={buttonStyle.LARY}
            buttonSize={buttonSize.XLG}
            iconType={icons.MSG}
            onClick={() => {
            }}
          />
        </FooterWrapper>
      </div>
    </div>
  );
};

export const PopSupport = () => {
  return (
    <div className="">

      <div className="m__head app--md__box">
        <div className="m__head__left">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-arw-l" />
          </a>
        </div>
        <div className="m__head__cent">
          <a href="javascript:void(null)" className="m__head__logo dn">
            <span className="i i-logo" />
          </a>
          <span className="m__head__titl">
            Support
          </span>
        </div>
        <div className="m__head__right">
        </div>
      </div>

      <div className="m__body app--md__box">
        <div className="m__body__titl">Need Assistance?</div>
        <p className="m__body__info">Talk to a Relay representative to get your problem solved today.</p>

        <div className="form__cont">
          <div className="input input--sm input--active">
            <span className="input--placeholder">404-295-9392</span>
            <label className="input__lbl">Call us</label>
          </div>

          <div className="input input--sm input--active">
            <span className="input--placeholder">info@relaypayments.com</span>
            <label className="input__lbl">Email us</label>
          </div>

          <div className="input input--sm input--area input--active">
            <textarea name="" id="" placeholder="Send us a message with your issue.." />
            <label className="input__lbl">Drop us a Line</label>
          </div>
        </div>

      </div>

      <div className="m__foot app--md__box">
        <div className="m__foot__btns">
          <a href="javascript:void(null)" className="btn btn--lgry btn--xlg ">
            Submit Message
          </a>
        </div>
      </div>
    </div>
  );
};

export const PopPaymentDetails = () => {
  return (
    <div className="m__ol ">
      <div className="m__head">
        <span className="m__head__titl m__ol__titl">
          Payment Detail
        </span>
        <div className="m__head__right">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-close-alt" />
          </a>
        </div>
      </div>
      <div className="m__body app--md__box">
        <div className="col__cont">
          <div className="col__row">
            <div className="col col--half">
              <div className="m__body__info__block">
                <div className="m__body__lbl">Amount</div>
                <div className="m__body__lbl__info">$45.50</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">Check number</div>
                <div className="m__body__lbl__info">32432413</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">D.L. NUMBER</div>
                <div className="m__body__lbl__info">92030132</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">PROCESSED</div>
                <div className="m__body__lbl__info">June 16, 2018</div>
              </div>
            </div>
            <div className="col col--half">
              <div className="m__body__info__block">
                <div className="m__body__lbl">PAYMENT TYPE</div>
                <div className="m__body__lbl__info">EFS</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">EXPRESS CODE</div>
                <div className="m__body__lbl__info">n/a</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">D.L. STATE</div>
                <div className="m__body__lbl__info">Georgia</div>
              </div>
              <div className="m__body__info__block">
                <div className="m__body__lbl">CONFIRMATION</div>
                <div className="m__body__lbl__info">9273</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m__foot">

        <div className="m__foot__btns">
          <a href="javascript:void(null)" className="btn btn--outl--lite btn--lgry btn--xlg ">
            <span className="btn__i">
              <span className="i i-msg" />
            </span>
            Send receipt as a text
          </a>
          <a href="javascript:void(null)" className="btn btn--outl--lite btn--lgry btn--xlg ">
            <span className="btn__i">
              <span className="i i-mail" />
            </span>
            Send receipt as an email
          </a>
        </div>
      </div>
    </div>
  );
};

export const PopPaymentCheck = () => {
  return (
    <div className="m__ol m__ol--trans">
      <a href="javascript:void(null)" className="m__head__anch">
        <span className="i i-close-alt" />
      </a>
      <div className="m__ol--trans__content">
        <img src="/assets/img/placeholder/check-info.png" alt="" />
      </div>
    </div>
  );
};

export const PopHistory = () => {
  return (
    <div className="">

      <div className="m__head app--md__box">
        <div className="m__head__left">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-arw-l" />
          </a>
        </div>
        <div className="m__head__cent">
          <span className="m__head__titl">
            History
          </span>
        </div>
        <div className="m__head__right">
          <a href="javascript:void(null)" className="m__head__anch">
            <span className="i i-search" />
          </a>
        </div>
      </div>

      <div className="input--search input--search--fw">
        <a href="javascript:void(null)" className="input__icon input--search__btn">
          <span className="i i-search" />
        </a>
        <input type="text" placeholder="Search" />
        <a href="javascript:void(null)" className="input__icon input--search__close">
          <span className="i i-close" />
        </a>
      </div>
      <div className="m__body app--md__box">
        {/* Need to add table so it can be styled probably */}
      </div>
    </div>
  );
};


class PageWrapper extends React.Component<Props, any> {
  render() {
    const {
      wrapperClass,
      children,
    } = this.props;

    return (
      <div className={`${wrapperClass || 'app__wrapper'}`}>
        <div className="app--dt">
          {children}
        </div>

        {/*
        <div className="app--md">
          <PopSupport />
          <LoginView />
          <PopPaymentStart />
          <PopPaymentDetails />
          <PopLoading />
          <PopPaymentFlow />
          <PopSuccess />
          <PopPaymentCheck />
          <PopHistory />
        </div>
        */}
      </div>
    );
  }
}

export default PageWrapper as any;
